export const MASTHEAD_ZIP_FORM_EVENTS = Object.freeze({
  ready: 'masthead-zip-form:ready'
});
